import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where
} from 'firebase/firestore';
import {
  createUserWithEmailAndPassword,
  deleteUser as deleteAuthUser
} from 'firebase/auth';
import { auth, db } from '../firebase/config';

const USERS_COLLECTION = 'users';

// Crear nuevo usuario
export const createUser = async (email, password, displayName, roleId) => {
  try {
    // Crear usuario en Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const uid = userCredential.user.uid;

    // Guardar datos adicionales en Firestore
    await setDoc(doc(db, USERS_COLLECTION, uid), {
      email,
      displayName,
      roleId,
      isActive: true,
      unlockAll: false, // Por defecto, usuarios normales no tienen acceso a contenido sensible
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });

    return { uid, email, displayName, roleId };
  } catch (error) {
    console.error('Error creando usuario:', error);
    throw error;
  }
};

// Obtener usuario por ID
export const getUserById = async (uid) => {
  try {
    const userDoc = await getDoc(doc(db, USERS_COLLECTION, uid));
    if (userDoc.exists()) {
      return { uid, ...userDoc.data() };
    }
    return null;
  } catch (error) {
    console.error('Error obteniendo usuario:', error);
    throw error;
  }
};

// Obtener todos los usuarios
export const getAllUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, USERS_COLLECTION));
    const users = [];
    querySnapshot.forEach((doc) => {
      users.push({ uid: doc.id, ...doc.data() });
    });
    return users;
  } catch (error) {
    console.error('Error obteniendo usuarios:', error);
    throw error;
  }
};

// Actualizar usuario
export const updateUser = async (uid, updates) => {
  try {
    await updateDoc(doc(db, USERS_COLLECTION, uid), {
      ...updates,
      updatedAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error actualizando usuario:', error);
    throw error;
  }
};

// Desactivar/Activar usuario (ban/unban)
export const toggleUserStatus = async (uid, isActive) => {
  try {
    await updateDoc(doc(db, USERS_COLLECTION, uid), {
      isActive,
      updatedAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error cambiando estado del usuario:', error);
    throw error;
  }
};

// Eliminar usuario
export const deleteUser = async (uid) => {
  try {
    // Eliminar de Firestore
    await deleteDoc(doc(db, USERS_COLLECTION, uid));
    // Nota: No podemos eliminar de Auth directamente aquí
    // Solo el usuario autenticado puede eliminar su propia cuenta
  } catch (error) {
    console.error('Error eliminando usuario:', error);
    throw error;
  }
};
